import { useMutation, useQueryClient } from '@tanstack/react-query'
import notificationService from '../../service'
import { notificationQueryKeys } from '../keys/notification.query-keys'

export const useMarkNotificationRead = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: notificationService.markRead,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notificationQueryKeys.all }),
    // Id không còn tồn tại / không thuộc user (404): làm mới để bỏ item khỏi danh sách
    onError: () => queryClient.invalidateQueries({ queryKey: notificationQueryKeys.all }),
  })
}
